import { fetchUser } from "actions/user";
import RequireData from "hooks/RequireData";
import React from "react";
import fetchUserStatusSelector from "selectors/fetchUserStatus";
import userSelector from "selectors/user";

const SettingsEmailRow: React.FC = () => {
    const [user, status] = RequireData(
        userSelector,
        fetchUserStatusSelector,
        fetchUser()
    );

    const text = React.useMemo(() => {
        if (status === "error") {
            return "Error. Reload to try again.";
        } else if (status === "loading" || !user) {
            return "Loading...";
        } else {
            return user.email;
        }
    }, [user, status]);

    return (
        <div>
            <h4>Email</h4>
            <p>{text}</p>
        </div>
    );
};

export default SettingsEmailRow;
